import { SharedMarkePlaceNoteValidation } from "@app/shared";
import React from "react";

const MarketPlaceNoteValidationList: React.FC = () => {
  return <SharedMarkePlaceNoteValidation />;
};

export default MarketPlaceNoteValidationList;
